import { BrowserRouter, Route, Routes, useLocation, useSearchParams } from 'react-router-dom';
import './app.scss';
import Identify from "./components/identify/identify";
import Main from "./components/mainv1/main";
import MainV2 from "./components/mainv2/main";
import PostSignature from "./components/postSignature/postSignature";
import ProceedToSign from "./components/proceedToSign/proceedToSign";

function MainRouter() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const version = searchParams.get('v');
  const isInsurance = location.pathname.startsWith('/insurance');
  const isPension = location.pathname.startsWith('/pension');
  const type = isInsurance ? 'insurance' : isPension ? 'pension' : 'pension';
  
  return version === '1' && isPension? <Main /> : <MainV2 type={type} />;
}

function App() {
  return (
    <div className="App">
        <BrowserRouter>
            <Routes>
                <Route
                    path="/"
                    element={<MainRouter/>}
                />
                <Route
                    path="/pension"
                    element={<MainRouter/>}
                />
                <Route
                    path="/insurance"
                    element={<MainRouter/>}
                />
                <Route
                    path="/sign"
                    element={<ProceedToSign />}
                />
                <Route
                    path="/post-signature"
                    element={<PostSignature />}
                />
                <Route
                    path="/t/:token"
                    element={<Identify />}
                />
                <Route
                    path="/pension/:token"
                    element={<Identify />}
                />
                <Route
                    path="/insurance/:token"
                    element={<Identify type="insurance" />}
                />
            </Routes>
        </BrowserRouter>

    </div>
  );
}

export default App;
